import React from 'react';
import styled from 'styled-components';
import { ErrorMessage } from './ErrorMessage';
import { Label } from './Label';

const Wrapper = styled.div`
    display: block;
`;

const InputWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const StyledInput = styled.input`
    width: 100%;
    height: 40px;
    color: ${p => p.theme.text};
    padding: 8px 12px;
    border-radius: 4px;
    border: none;
    background-color: ${p => p.theme.background};
    font-family: ${p => p.theme.fontFamily};
    font-weight: ${p => p.theme.fontWeight.regular};
    ::placeholder {
        color: ${p => p.theme.textLight};
        opacity: 1;
    }
`;

const checkKeyDown = e => {
    if (e.code === 'Enter') e.preventDefault();
};

export const TextField = React.forwardRef((props, ref) => {
    const {
        id,
        required,
        disabled,
        label,
        placeholder,
        onKeyDown = checkKeyDown,
        error,
        icon,
        ...otherProps
    } = props;

    return (
        <Wrapper>
            {label ? (
                <Label>{label}{required ? ' (required)' : ' (optional)'}</Label>
            ) : null}
            <InputWrapper>
                <StyledInput
                    {...otherProps}
                    type="text"
                    id={id}
                    disabled={disabled}
                    placeholder={placeholder && `${placeholder}${required ? ' (required)' : ' (optional)'}`}
                    onKeyDown={onKeyDown}
                    ref={ref}
                />
                {icon}
            </InputWrapper>
            {error ? (
                <ErrorMessage>{error.message}</ErrorMessage>
            ) : null}
        </Wrapper>
    );
});
